import { Dispatch } from '@reduxjs/toolkit'
import jwtDecode, { JwtPayload } from 'jwt-decode'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, Navigate } from 'react-router-dom'

import { getUser, setLoggedUser, setTokenUser } from '../store/auth'

const PrivateRoutes = () => {
  const user = useSelector(getUser)
  const dispatch = useDispatch<Dispatch<any>>()

  // const [loggedIn, setLoggedIn] = React.useState<JwtPayload | undefined>(undefined)

  // React.useEffect(() => {
  //   const token = localStorage.getItem('token')
  //   if (token !== null) {
  //     const decodedToken = jwtDecode<JwtPayload>(token)
  //     if (decodedToken !== undefined) {
  //       dispatch(setLoggedUser(decodedToken))
  //       dispatch(setTokenUser(token))
  //       setLoggedIn(decodedToken)
  //     }
  //   }
  // }, [])

  return user !== undefined ? <Outlet /> : <Navigate to='/Login' />
}

export default PrivateRoutes
